// extracted by mini-css-extract-plugin
module.exports = {"card":"CategoryCard_card__X0mce","title":"CategoryCard_title__neQeB","palette-light":"CategoryCard_palette-light__SgYYA","palette-dark":"CategoryCard_palette-dark__vMyQr"};